import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { USER_TYPES } from '@medflex/utils/constants';
import AddressBook from '@medflex/components/stories/AddressBook';
import Badge, { KINDS } from '@medflex/components/stories/Badge';
import { FEATURE_KEYS } from '@medflex/utils/subscriptionEnums';
import useFeatures from '../../hooks/useFeatures';
import useUserProfile from '../../hooks/useUserProfile';
import { MODALS } from '../../hooks/useIsModal';
import useModal from '../../hooks/useModal';

const InvitationBarModule = ({ sort }) => {
  const { userProfile } = useUserProfile();
  const { type: userType } = userProfile;
  const { t } = useTranslation('physician', { keyPrefix: 'InvitationBarModule' });
  const [staffPhysician, staffAssistant] = useFeatures([
    FEATURE_KEYS.STAFF_PHYSICIAN,
    FEATURE_KEYS.STAFF_ASSISTANT,
  ]);
  const { open } = useModal();

  const allOrArchive = ['all', 'archive'];

  if (!sort || allOrArchive.includes(sort)) {
    return (
      <AddressBook.InvitationButton onClick={() => open({ modal: MODALS.contactInvite })}>
        {t('addContact')}
      </AddressBook.InvitationButton>
    );
  }

  if (userType === USER_TYPES.PHYSICIAN && sort === 'staff') {
    return (
      <AddressBook.InvitationButton
        onClick={() =>
          open({
            modal:
              staffPhysician.active || staffAssistant.active
                ? MODALS.staff_type
                : MODALS.featureUpgradeStaffAssistant,
          })
        }
      >
        {t('team')}
        {!staffPhysician.active && !staffAssistant.active && (
          <Badge kind={KINDS.SIGNAL} className="ml-2">
            {t('upgrade')}
          </Badge>
        )}
      </AddressBook.InvitationButton>
    );
  }

  if (sort === 'physicians') {
    return (
      <AddressBook.InvitationButton onClick={() => open({ modal: MODALS.invitePhysician })}>
        {t('physician')}
      </AddressBook.InvitationButton>
    );
  }

  if (['patients', 'invited'].includes(sort)) {
    return (
      <AddressBook.InvitationButton onClick={() => open({ invitePatient: 'email' })}>
        {t('patient')}
      </AddressBook.InvitationButton>
    );
  }

  if (sort === 'groups') {
    return (
      <AddressBook.InvitationButton onClick={() => open({ modal: MODALS.sessionChatCreate })}>
        {t('group')}
      </AddressBook.InvitationButton>
    );
  }

  return null;
};

InvitationBarModule.propTypes = {
  sort: PropTypes.oneOf(['all', 'staff', 'physicians', 'patients', 'groups', 'archive', 'invited']),
};

export default InvitationBarModule;
